import { render, staticRenderFns } from "./xglist.vue?vue&type=template&id=1d23aae2&"
import script from "./xglist.vue?vue&type=script&lang=js&"
export * from "./xglist.vue?vue&type=script&lang=js&"
import style0 from "./xglist.vue?vue&type=style&index=0&id=1d23aae2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d23aae2')) {
      api.createRecord('1d23aae2', component.options)
    } else {
      api.reload('1d23aae2', component.options)
    }
    module.hot.accept("./xglist.vue?vue&type=template&id=1d23aae2&", function () {
      api.rerender('1d23aae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/categorylist/xglist.vue"
export default component.exports